import { DeviceModelOutputWithStatusAndDeviceModelPortSpecification } from './device-model-output-with-status-and-device-model-port-specification.model';


export class DeviceModelSelectByIdOutput implements IDeviceModelSelectByIdOutput {
    status!: number;
    message!: string;
    data!: DeviceModelOutputWithStatusAndDeviceModelPortSpecification;

    constructor(data?: IDeviceModelSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? DeviceModelOutputWithStatusAndDeviceModelPortSpecification.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DeviceModelSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceModelSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IDeviceModelSelectByIdOutput {
    status: number;
    message: string;
    data: DeviceModelOutputWithStatusAndDeviceModelPortSpecification;
}

